const SPEEDCHIP_SELECTOR_IMAGES = {
    ebike: "https://cdn.shopify.com/s/files/1/0831/5486/2425/files/speedchip-selector-ebike.webp?v=1791732207",
    scooter: "https://cdn.shopify.com/s/files/1/0831/5486/2425/files/speedchip-selector-scooter.webp?v=1791732215"
};

function getVehicleCard(text) {
    if (text === "E-bike") {
        return `<div class="selector-card-image"><img src="${SPEEDCHIP_SELECTOR_IMAGES.ebike}" alt="E-bike" loading="eager"></div>`;
    }

    if (text === "E-hulajnoga") {
        return `<div class="selector-card-image"><img src="${SPEEDCHIP_SELECTOR_IMAGES.scooter}" alt="E-hulajnoga" loading="eager"></div>`;
    }

    return "";
}

function isVehicleRoot(gridElementsArray) {
    const labels = gridElementsArray.map(item => item.text || "");
    return labels.includes("E-bike") && labels.includes("E-hulajnoga");
}

function fetchJsonAndDisplay() {
    const url = window.selector_json_url;

    fetch(url)
    .then(response => response.json())
    .then(jsonData => {
        fillOptions(jsonData.SectionContent.GridElementsArray);
        updatewizzard_question(jsonData.SectionContent.title);
    })
    .catch(error => {
        console.error('Error fetching JSON:', error);
        document.getElementById('wizzard_question').innerText = "Error loading content.";
    });
}

function fillOptions(gridElementsArray) {
    const optionsDiv = document.getElementById('options');
    const wizard = document.getElementById('wizard');
    const rootMode = isVehicleRoot(gridElementsArray);

    optionsDiv.innerHTML = "";
    optionsDiv.classList.toggle('vehicle-root-options', rootMode);
    if (wizard) wizard.classList.toggle('vehicle-root', rootMode);

    gridElementsArray.forEach(function(item) {
        const text = item.text ? item.text : "";
        const vehicleCard = getVehicleCard(text);

        if (vehicleCard && rootMode) {
            optionsDiv.innerHTML += `<div onclick='myFunction(${JSON.stringify(item)})' class='panel vehicle-panel' role='button' tabindex='0' aria-label='${text}'>${vehicleCard}</div>`;
        } else {
            const visual = item.imageSource ? `<img class='logo' src='${item.imageSource}' alt='${text}'>` : "";
            optionsDiv.innerHTML += `<div onclick='myFunction(${JSON.stringify(item)})' class='panel'>${visual}<p id='label'>${text}</p></div>`;
        }
    });
}

function myFunction(item) {
    if (item.target === "ReturnAction") {
        goBack();
    } else if (typeof item.target === 'string') {
        window.location.href = item.target;
    } else if (item.target && item.target.SectionContent && item.target.SectionContent.GridElementsArray) {
        fillOptions(item.target.SectionContent.GridElementsArray);
        updatewizzard_question(item.target.SectionContent.title);
    }
    updateScrollPosition();
}

function updateScrollPosition(){
    const banner = document.getElementById('wizzard_banner');
    if (!banner) return;
    const rect = banner.getBoundingClientRect();
    const scrollPosition = window.pageYOffset + rect.top - 40;
    window.scrollTo({ top: scrollPosition, behavior: 'auto' });
}

function updatewizzard_question(title) {
    const question = document.getElementById('wizzard_question');
    if (question) question.innerHTML = title;
}

function goBack() {
    fetchJsonAndDisplay();
}

document.addEventListener('DOMContentLoaded', fetchJsonAndDisplay);